import { Component, ViewChild } from '@angular/core';

import { OrdersChartComponent } from './charts/line-chart.component';
import { ProfitChartComponent } from './charts/bar-chart.component';
import { ActivatedRoute } from '@angular/router';
import { HeaderChartSummary, DashboardTransactionsChart } from '../types/dashboard';
import { DashboardData, TransactionSummary } from '../../../../@core/data/dashboard-data';

@Component({
  selector: 'ngx-transactions-charts',
  styleUrls: ['./transactions-charts.component.scss'],
  templateUrl: './transactions-charts.component.html',
})
export class TransactionsChartsComponent {

  headerSummary: HeaderChartSummary[];
  transactionsChartData: DashboardTransactionsChart;

  shouldDisplay = false;

  @ViewChild('transactionsLineChart', { static: true }) transactionsLineChart: OrdersChartComponent;
  @ViewChild('transactionsbarChart', { static: true }) transactionsbarChart: ProfitChartComponent;

  constructor(private dashsboarData: DashboardData, private route: ActivatedRoute) {
    this.route.params
      .subscribe(params => {
        this.dashsboarData.getTodayTransactionSummary(params.oid, params.gid)
          .subscribe(transactionsData => {
            this.parseData(transactionsData);
            this.shouldDisplay = this.transactionsChartData?.chartLabel.length > 0;
          });
      });
  }

  changeTab(selectedTab: { tabTitle: string; }) {
    if (selectedTab.tabTitle === 'Visão Alternativa') {
      this.transactionsbarChart?.resizeChart();
    } else {
      this.transactionsLineChart?.resizeChart();
    }
  }

  private parseData(data: TransactionSummary[]) {
    let allArray = [];
    let processedArray = [];
    let cancelledArray = [];
    let labelsArray = [];
    let creditCount: number = 0;
    let debitCount: number = 0;
    let totalTransactions: number = 0;
    let totalCanceled: number = 0;
    let totalSales: number = 0.00;

    for (var i = 0; i < data.length; i++) {
      allArray.push(data[i].all);
      processedArray.push(data[i].processed);
      cancelledArray.push(data[i].cancelled);
      labelsArray.push(data[i].paymentHour);
      creditCount += data[i].creditTransactions
      debitCount += data[i].debitTransactions;
      totalTransactions += data[i].all;
      totalCanceled += data[i].cancelled;
      totalSales += data[i].amount;
    }

    const chartsData = {
      chartLabel: labelsArray,
      linesData: [
        allArray,
        processedArray,
        cancelledArray
      ],
    };

    var brl = parseFloat(totalSales.toString()).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    const summary = [
      {
        title: 'Total Transações',
        value: totalTransactions.toString(),
      },
      {
        title: 'Total Vendas',
        value: brl,
      },
      {
        title: 'Vendas Crédito',
        value: creditCount.toString(),
      },
      {
        title: 'Vendas Débito',
        value: debitCount.toString(),
      },
      {
        title: 'Cancelados',
        value: totalCanceled.toString(),
      },
    ];

    this.headerSummary = summary;

    this.transactionsChartData = chartsData;
  }
}
